import Vue from "vue";
import Router from "vue-router";
// 路由懒加载
const _import_ = file => () => import(`@/views/${file}.vue`);
import Layout from "@/views/layout/index.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/home",
      alwaysShow: false,
      children: [
        {
          path: "/home",
          name: "Home",
          component: _import_("home/index"),
          meta: {
            title: "首页"
          }
        }
      ]
    },
    {
      path: "/product",
      name: "Product",
      component: Layout,
      alwaysShow: true,
      meta: {
        title: "产品中心"
      },
      children: [
        {
          path: "car-door",
          name: "CarOrDoor",
          component: _import_("product/index"),
          meta: {
            title: "智能通行"
          },

        },
        {
          path: "smart-view",
          name: "SmartView",
          component: _import_("product/index"),
          meta: {
            title: "智能视图"
          },

        },
        {
          path: "viewai",
          name: "Viewai",
          component: _import_("product/index"),
          meta: {
            title: "智能大数据"
          },

        },
        {
          path: "optical-alarm",
          name: "OpticalAlarm",
          component: _import_("product/index"),
          meta: {
            title: "智慧光纤"
          }
        },
        {
          path: "software",
          name: "Software",
          component: _import_("product/index"),
          meta: {
            title: "智能平台服务"
          }
        },
        {
          path: "product-detail",
          name: "ProductDetail",
          hidden: true,
          component: _import_("product/detail"),
          meta: {
            title: "产品详情"
          }
        },
        {
          path: "product-group",
          name: "ProductGroup",
          hidden: true,
          component: _import_("product/group"),
          meta: {
            title: "产品中心"
          }
        }
      ]
    },

    {
      path: "/cases",
      name: "Cases",
      component: Layout,
      alwaysShow: true,
      meta: {
        title: "解决方案"
      },
      children: [
        {
          path: "social",
          name: "social",
          component: _import_("solutions/social/index"),
          meta: {
            title: "基层社会治理"
          }
        },
        {
          path: "AIOT",
          name: "AIOT",
          component: _import_("solutions/AIOT/index"),
          meta: {
            title: "AIOT数智管理"
          }
        },
        {
          path: "oilStation",
          name: "oilStation",
          component: _import_("solutions/oilStation/index"),
          meta: {
            title: "智慧加油站"
          }
        },
        {
          path: "SmartConstruction",
          name: "SmartConstruction",
          component: _import_("solutions/SmartConstruction/index"),
          meta: {
            title: "智慧工地"
          }
        },
        {
          path: "intelligence",
          name: "intelligence",
          component: _import_("solutions/intelligentCall/index"),
          meta: {
            title: "智慧监狱"
          }
        },
        {
          path: "motor",
          name: "motor",
          component: _import_("solutions/motor/index"),
          meta: {
            title: "5G+AI智慧铁骑"
          }
        },
        {
          path: "optical",
          name: "Optical",
          component: _import_("solutions/optical/index"),
          meta: {
            title: "分布式光纤振动安防报警视频联动"
          }
        },
      ]
    },
    {
      path: "/news",
      component: Layout,
      redirect: "/news",
      alwaysShow: false,
      children: [
        {
          path: "/news",
          name: "News",
          component: _import_("news/index"),
          meta: {
            title: "媒体中心"
          }
        },
        {
          path: "detail",
          name: "Detail",
          component: _import_("news/detail"),
          meta: {
            title: "媒体详情"
          }
        }
      ]
    },
    {
      path: "/service",
      component: Layout,
      redirect: "/service",
      alwaysShow: false,
      children: [
        {
          path: "/service",
          name: "Service",
          component: _import_("service/index"),
          meta: {
            title: "服务支持"
          }
        }
      ]
    },
    {
      path: "/about",
      name: "About",
      component: Layout,
      redirect: "/about",
      alwaysShow: true,
      meta: {
        title: "关于我们"
      },
      children: [
        {
          path: "us",
          name: "Us",
          component: _import_("about/us"),
          meta: {
            title: "公司简介"
          }
        },
        {
          path: "join",
          name: "Join",
          component: _import_("about/join"),
          meta: {
            title: "加入我们"
          }
        }
      ]
    }
  ]
});
